import axios from 'axios';
import { API_CONFIG } from './config';
import {
  requestErrorInterceptor,
  requestInterceptor,
  responseErrorInterceptor,
  responseInterceptor,
} from './interceptors';

// 创建axios实例
const instance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS,
  withCredentials: false, // 不自动发送 cookie，避免 CORS 问题（token 通过 header 手动传递）
});

// 添加拦截器
instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
// 导出请求函数
const request = (config) => {
  return instance(config);
};

// 添加便捷方法
request.get = (url, params = {}) => instance.get(url, { params });
request.post = (url, data = {}) => instance.post(url, data);
request.put = (url, data = {}) => instance.put(url, data);
request.delete = (url) => instance.delete(url);
request.upload = (url, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return instance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default request; 